// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__wCp-s","footer-dark":"footer_footer-dark__13YXp"};